import { Box, styled } from '@mui/material';
import React, { useState } from 'react';

import { TabNavigation } from './TabNavigation/TabNavigation';
import { getBottomTabsData, getTopTabsData } from './TabNavigation/utils';
import { TabValue } from './TabNavigation/types';
import auth from 'utils/auth';
import { ROUTE_TO_TAB_MAP } from './utils/utils';
import { useHistory } from 'react-router';

const JobViewTabs: React.FC<{ jobId: number; tab: string }> = ({ jobId, tab }) => {
  const tabId = ROUTE_TO_TAB_MAP[tab] || 0;
  const [selectedTab, setSelectedTab] = useState<TabValue>(tabId);
  const history = useHistory();

  const isDistrictAdmin = auth.isDistrictAdmin();
  const inPostingOnlyDistrict = auth.inPostingOnlyDistrict();
  const isAtsLiteDistrict = auth.isAtsLiteDistrict();

  const topTabsData = getTopTabsData(jobId, isDistrictAdmin, inPostingOnlyDistrict);
  const bottomTabsData = getBottomTabsData(
    jobId,
    isDistrictAdmin,
    inPostingOnlyDistrict,
    isAtsLiteDistrict
  );
  const allTabsData = [...topTabsData, ...bottomTabsData];

  const handleTabChange = (_: React.SyntheticEvent, newValue: TabValue): void => {
    const candidatesTabIndex = 5;
    const tab = allTabsData.find((tab) => tab.value === newValue);

    if (!tab) return;

    if (newValue === candidatesTabIndex) {
      window.open(tab.route, '_blank', 'noopener,noreferrer');
    } else {
      setSelectedTab(newValue);
      history.push(tab.route);
      window.scrollTo(0, 0);
    }
  };

  return (
    <Content>
      <TabNavigation
        onChange={handleTabChange}
        selectedTab={selectedTab}
        topTabsData={topTabsData}
        bottomTabsData={bottomTabsData}
      />
      <TabContentContainer>
        {allTabsData.find((data) => data.value === selectedTab)?.content}
      </TabContentContainer>
    </Content>
  );
};

export default JobViewTabs;

const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(2),
  maxWidth: '1200px',
  marginTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.border.main}`,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));

const TabContentContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  marginBottom: theme.spacing(1),
  marginLeft: theme.spacing(8),
  marginTop: theme.spacing(2),
  maxWidth: theme.breakpoints.values.lg,
  width: '100%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    margin: 0,
    maxWidth: '100%',
  },
}));
